import React, { useState } from "react";
import SearchBar from "../searchbar/SearchBar";
import "./home.css";

function Home({ onHideBanner, onResultsMode }) {
const [query, setQuery] = useState(""); // Track the query

// Function to handle search
const handleSearch = (searchQuery) => {
if (searchQuery.trim() === "") {
return;
}

};

return (
<div className="responsive-container">
  <div className="searchBarContent1">

<SearchBar
query={query}
setQuery={setQuery}
handleSearch={handleSearch}
onHideBanner={onHideBanner}
onResultsMode={onResultsMode}
/>

{/* <Footer /> */}
</div>
  </div>


);
}

export default Home;
